import { atom } from 'recoil'

export const opportunityFormModalEmail = atom<string>({
  key: 'opportunityFormModalEmail',
  default: ''
})
